export default {"src":"/_next/static/media/rocket.ba751270.svg","height":300,"width":300};